import React, { FC, useEffect } from "react";
import { MunicipiosListPage } from "../modules/municipios-list-page";
import { HeaderGenericContainer } from "../modules/header-generic/header-generic.container";
import { SearchBarContainer } from "../components/SearchBar/SearchBar.container";
import { LoginAreaContainer } from "../modules/login-area/login-area.container";

export const MunicipiosList: FC = () => {
  useEffect(() => {
    if (globalThis.window !== undefined && globalThis.window.scrollY !== 0) {
      globalThis.window.scrollTo(0, 0);
    }
  }, []);

  return (
    <div>
      <HeaderGenericContainer
        centerElement={<SearchBarContainer />}
        rightElement={<LoginAreaContainer variant="blue" />}
      />
      <div>
        <MunicipiosListPage />
      </div>
    </div>
  );
};
